module.exports = __webpack_public_path__ + "img/feature.7ab69c29.png";